import React from 'react'
import Navbar from '../../../layout/Navbar'
import Hero from './Hero'
import "../WebPage.css"
import ServiceDetail from './ServiceDetail'
import Footer from '../../../layout/Footer'

const WEbPage = () => {
  return (
    <div>
      <Navbar />
      <Hero />
      <ServiceDetail />
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <Footer />
    </div>
  )
}

export default WEbPage
